import styled from "styled-components";

export const CentrosLaboContainer = styled.div`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
`;
export const CentrosLaboHeader = styled.div`
  padding: 52px 28px 30px 28px;
  display: flex;
  justify-content: center;
  span {
    color: var(--color-latex15);
    text-align: center;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
`;
export const CentrosLaboBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CentrosLaboBoton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  font-size: 24px;
  width: 540px;
  height: 72px;
  border-radius: 12px;
  background: ${(props) =>
    props.selected
      ? "var(--color-primary)"
      : `var(
    --Grandiente-cards,
    linear-gradient(258deg, #027bc0 18.65%, #004b76 86.55%)
  )`};
  box-shadow: 3px 7px 11px 0px rgba(0, 0, 0, 0.25);
`;

